module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "testsblock"
  }, [(_vm.date.length) ? [(_vm.isResult) ? _c('p', {
    staticClass: "testsblock__date testsblock__date_green"
  }, [_vm._v("Проверочная работа выполнена " + _vm._s(_vm.dateTestResult))]) : _vm._e()] : _vm._e(), (_vm.isOpenBlock) ? _c('p', {
    staticClass: "testsblock__link",
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Закрыть")]) : [(!_vm.isResult) ? _c('p', {
    staticClass: "testsblock__link",
    on: {
      "click": function($event) {
        return _vm.$emit("lookItems")
      }
    }
  }, [_vm._v("Выполнить проверочную работу")]) : _c('p', {
    staticClass: "testsblock__link",
    on: {
      "click": function($event) {
        return _vm.$emit("lookItems")
      }
    }
  }, [_vm._v("Посмотреть результат")])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a72c652c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/info/components/block/components/legend/components/testsblock/TestsBlock.vue
// module id = 337962d0e12ccd104a41
// module chunks = 89